import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectActiveTableCellRowIds } from 'services/selectedTableCells/selectors';
import { SprayEventUuid } from 'services/sprayEvents/types';

const selectCopySprayEventUuid = createDeepEqualSelector(
    selectActiveTableCellRowIds,
    (uuids: SprayEventUuid) => get(uuids, 0)
);

const makeSelectCopySprayEventUuid = (): typeof selectCopySprayEventUuid =>
    selectCopySprayEventUuid;

export { makeSelectCopySprayEventUuid };
